import { baseGetNoId } from 'services/base-services/baseService';
import { API2_HOST } from 'helpers/urlHelper';
const baseURL = `${API2_HOST}/eva-odr-automatic-report`;

const updateOdrAutomaticHtml = async () => {
  return await baseGetNoId(`${baseURL}/get-report-html`);
};

const getOtifOdrChartHtml = async () => {
  const res = await fetch(`${baseURL}/otif-odr-chart`, {
    credentials: 'include'
  });
  const json = await res.json();
  return json.data;
};

export { updateOdrAutomaticHtml, getOtifOdrChartHtml };
